import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

const PoliciesTableNameCell = ({ item: policy, ...cellProps }: TableSimpleCellProps<Policy>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/policy/${policy.id}`}>{policy.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default PoliciesTableNameCell;
